"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userOrganizationFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Profiles_1 = require("../Profiles");
const email_address_factory_1 = require("./email-address.factory");
const phone_number_factory_1 = require("./phone-number.factory");
exports.userOrganizationFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    uuid: Factory.each(() => uuid_1.v4()),
    email_address: email_address_factory_1.emailAddressFactory.build(),
    phone_number: phone_number_factory_1.phoneNumberFactory.build(),
    self_persona: Profiles_1.personaOrganizationFactory.build()
});
